import { GridColDef } from "@mui/x-data-grid";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import { Button, CommonPagination, GKTable } from "components";
import { ReloadIcon } from "components/Icons";
import { useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

const PortfolioList = () => {
  const queryClient = useQueryClient();

  const {
    state: { commonFilter },
  } = useAppContext();

  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const requestBody = {
    requireTotalCount: true,
    take: commonFilter?.portfolioList?.take,
    skip: commonFilter?.portfolioList?.skip,
    sort: JSON.stringify(
      commonFilter?.portfolioList?.sortModel?.map((data: any) => {
        return {
          selector: data.field,
          desc: data.sort !== "asc",
        };
      })
    ),
    search: commonFilter?.portfolioList?.search || "",
  };

  const { data: portfolioListData, isFetching } = useQuery({
    queryKey: ["PORTFOLIO_LIST", requestBody],
    queryFn: () =>
      axiosInstance.get(`/super_admin/all_portfolio_id/`, {
        params: requestBody,
      }),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  console.log(portfolioListData?.data?.data, "portfolioListData");

  const { mutate: refreshPortfolio, isLoading } = useMutation({
    mutationKey: ["REFRESH_PORTFOLIO"],
    mutationFn: (ids: number[]) =>
      axiosInstance.post(`/super_admin/refresh/`, {
        portfolio_id: ids,
      }),
    onSuccess: (response) => {
      toast.success(
        response?.data?.message || "Refresh Portfolio Successfully"
      );
      queryClient.invalidateQueries({ queryKey: ["PORTFOLIO_LIST"] });
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("id", "id", 200, 1),
    },
    {
      ...extraColumnsField("Portfolio Name", "name", 200, 1),
    },
    {
      ...extraColumnsField("Portfolio ID", "portfolioId", 200, 1),
    },
  ];

  const cusPagination = () => {
    return (
      <CommonPagination
        name="portfolioList"
        totalCount={portfolioListData?.data?.totalCount || 0}
      />
    );
  };

  return (
    <GKTable
      loading={isFetching}
      columns={columns}
      rows={portfolioListData?.data?.data || []}
      name="portfolioList"
      checkboxSelection
      onRowSelectionModelChange={(ids: any) => {
        setSelectedRows(ids);
      }}
      CustomPagination={!isFetching && cusPagination}
      headerComponent={
        <Button
          variant="contained"
          startIcon={<ReloadIcon />}
          onClick={() => {
            if (selectedRows.length === 0) {
              toast.error("Please select at least one portfolio");
              return;
            }
            refreshPortfolio(selectedRows);
          }}
          disabled={isLoading || selectedRows.length === 0}
        >
          {isLoading ? "Refreshing..." : "Refresh"}
        </Button>
      }
    />
  );
};

export default PortfolioList;
